// Auth0 configuration
// Replaces Cognito OIDC configuration

export interface Auth0Config {
  domain: string
  clientId: string
  audience: string
  redirectUri: string
}

// Cache for loaded config
let configCache: Auth0Config | null = null
let configPromise: Promise<Auth0Config | null> | null = null

/**
 * Load Auth0 configuration from aws-exports.json at runtime.
 * Falls back to VITE_ environment variables.
 */
export async function loadAuth0Config(): Promise<Auth0Config> {
  if (configCache) return configCache

  if (configPromise) {
    const result = await configPromise
    if (result) return result
  }

  configPromise = (async () => {
    try {
      const response = await fetch("/aws-exports.json")
      if (response.ok) {
        const config = await response.json()
        configCache = {
          domain: config.auth0Domain || import.meta.env.VITE_AUTH0_DOMAIN || "",
          clientId: config.auth0ClientId || import.meta.env.VITE_AUTH0_CLIENT_ID || "",
          audience: config.auth0Audience || import.meta.env.VITE_AUTH0_AUDIENCE || "",
          redirectUri: config.redirect_uri || window.location.origin,
        }
        return configCache
      }
    } catch {
      // aws-exports.json not available, fall back to env vars
    }

    configCache = {
      domain: import.meta.env.VITE_AUTH0_DOMAIN || "",
      clientId: import.meta.env.VITE_AUTH0_CLIENT_ID || "",
      audience: import.meta.env.VITE_AUTH0_AUDIENCE || "",
      redirectUri: import.meta.env.VITE_AUTH0_REDIRECT_URI || window.location.origin,
    }
    return configCache
  })()

  return configPromise as Promise<Auth0Config>
}
